import logIt from '../../../logIt';
import decodeHTML from './decodeHTML';

// This function is used for adding option property of msg.options object
const addOptionProperty = (options) => {
    try {
        const type = typeof options;
        if (type === 'string') {
            // most probably consent QT
            let parsedOptions = ApexChat.TryParse(options);
            if (typeof parsedOptions === 'string') {
                parsedOptions = ApexChat.TryParse(parsedOptions);
                return parsedOptions;
            }
        }
        // add option property to msg.options object
        if (options && options.length && options.length > 0) {
            // check if options property exists
            // don't try parsing if already JSON
            options = ApexChat.TryParse(options);
            options.forEach((element) => {
                if (!element.option) {
                    element.option = element.text; // copy value of text property to new option property in msg.options object.
                } else {
                    element.option = decodeHTML(element.option); // convert into html.
                }
            });
            return type === 'object' ? options : JSON.stringify(options); // return msg.options object with new option property added.
        }
    } catch (ex) {
        logIt(ex);
    }
};
export default addOptionProperty;
